import {isNullOrUndefined} from "../../services/Validator";

function SystemFlashTopTexts({title, subtitle, extraClass}) {
    // Used in FlashResultsScreen to display step title and subtitle
    // in Desktop mode

    // BUILD
    if (isNullOrUndefined(title) && isNullOrUndefined(subtitle))
        return null
    return(
        <div className={"w-full grow hidden sm:flex sm:flex-col items-center leading-none space-y-6 " + extraClass}>
            <span className="font-semibold text-white text-[18px] text-center">
                {title}
            </span>
            <span className="font-normal text-greyLight7 text-[16px] text-center">
                {subtitle}
            </span>
        </div>
    );
}

// EXPORT
export default SystemFlashTopTexts